import styled from "styled-components";

export const Disabled = styled.div`
  cursor: not-allowed !important;
  input {
    user-select: none;
  }

  opacity: 0.6;
  span {
    opacity: 0.6;

    &:hover {
      opacity: 0.6;
    }
  }
`;
